import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { RestatementBatch } from "../../../domains/RestatementBatch"
import { Restatement } from "../../../domains/Restatement"
import { AaRestatementService } from "../service/aa-restatement.service";
import { GemsService } from 'client/app/shared';
import { concatMap, map } from 'rxjs/operators';

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['../../../shared/styles/aa.less'],
  standalone: false
})
export class CompleteComponent implements OnInit {
  @Input() aaSelected: Restatement[];
  @Output() back = new EventEmitter<boolean>();

  restatementBatch: RestatementBatch;

  dontShowSummary = true;
  showConfirmMessage = true;

  alert: { caption?: string; text?: string };

  constructor(
    private aaRestatementService: AaRestatementService,
    private gemsService: GemsService
  ) { }

  ngOnInit(): void {
    this.alert = {
      text: "Please double-check all of the information below before confirming the transaction."
    };
  }

  navigateBack() {
    this.back.emit(true);
  }

  submitRestatements() {

    /*    let document: Restatement = {
         DocumentHeaderId: data[i].DocumentHeaderId,
         AdoptionAgreementId: data[i].AdoptionAgreementId,
         AddendumId: data[i].AddendumId,
         PlanDocument: data[i].PlanDocument,
         PlanType: data[i].PlanType,
         SubgroupId: data[i].SubgroupId,
         AddendumDocuments: data[i].AddendumDocuments
       } */
    var documentIds: string[] = [];
    var isRestatementFlag: boolean;
    for (let i = 0; i < this.aaSelected.length; i++) {
      documentIds.push(this.aaSelected[i].DocumentHeaderId)
      isRestatementFlag = this.aaSelected[i].isRestatement
    }

    if (isRestatementFlag) {
      this.gemsService.getUser().pipe(
        map(user => ({
          DocumentIds: documentIds,
          SubmittedBy: user.person_id
        } as RestatementBatch)),
        concatMap(batch => this.aaRestatementService.submitRestatements(batch))
      ).subscribe()
    }
    else {
      this.gemsService.getUser().pipe(
        map(user => ({
          DocumentIds: documentIds,
          SubmittedBy: user.person_id
        } as RestatementBatch)),
        concatMap(batch => this.aaRestatementService.submitNonRestatements(batch))
      ).subscribe();
    }

    this.dontShowSummary = false;
    this.showConfirmMessage = false;
  }
}
